module.exports = __webpack_public_path__ + "img/v05.b4b2ad23.jpg";